import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import coordinatesIcon from "../assets/images/coordinates.png";
import currentLocationIcon from "../assets/images/currentLocationIcon.png";
import cursorIcon from "../assets/images/hover-coordinates.png"; // Add your new icon here
import WorldView from "../assets/images/world-view.png"; // Import your WorldView icon
import aoiIcon from "../assets/images/aoi.png";
import CountryDropdown from "../assets/images/country-dropdown.png";
//import Countries from '../assets/countriesJSON/countries.json'; // Import the JSON file
import KMLUpload from "../assets/images/KMLUplode.png";
 // eslint-disable-next-line
import { Autocomplete } from "@react-google-maps/api";
// eslint-disable-next-line
import { useEffect } from "react";


const Sidebar = ({
  setKmlUrl,
  onCountrySelect,
  setCenter,
  setCaptureCoordinates,
  setZoomLevel,
  zoomToDrawnShapes,
  setMarkerPosition,
  setCurrentLocationMarkerPosition,
  onKMLUpload,
  onLoadAutocomplete,       // ✅ added
  onPlaceChanged            // ✅ added
}) => {

 // eslint-disable-next-line
  const [latitude, setLatitude] = useState("");
   // eslint-disable-next-line
  const [longitude, setLongitude] = useState("");
   // eslint-disable-next-line
  const [showPopup, setShowPopup] = useState(false);
   // eslint-disable-next-line
  const [showkmluploder, setShowkmlUploder] = useState(false);
  // eslint-disable-next-line 
  const [showSearchBox, setShowSearchBox] = useState(false);
  //const [showDropdown, setShowDropdown] = useState(false); // State for dropdown popup
  //const [selectedCountry, setSelectedCountry] = useState(""); // State to store selected country
  const [isWorldView, setIsWorldView] = useState(false);
  const [selectedIcon, setSelectedIcon] = useState("");
  const [isCursorActive, setIsCursorActive] = useState(false);
  const handleIconClick = (icon) => {
  setSelectedIcon(icon);


  if (icon === "KMLUpload") {
    setShowkmlUploder(true);
  }

  handleDefaultView?.(); // Optional call if defined
};

 // eslint-disable-next-line
  const handleSetCoordinates = () => {
    const lat = parseFloat(latitude);
    const lng = parseFloat(longitude);

    if (!isNaN(lat) && !isNaN(lng)) {
      setCenter({ lat, lng }); // Update the center of the map
      setMarkerPosition({ lat, lng }); // Set the marker position
      setShowPopup(false); // Close the popup after setting coordinates
      if (isWorldView) {
        setZoomLevel(12); // Zoom in when coming from world view
        setIsWorldView(false); // Reset world view flag after zooming in
      }
    } else {
      alert("Please enter valid coordinates");
    }
  };

  const handleCancel = () => {
    setShowPopup(false); // Close the popup without setting coordinates
    //setShowDropdown(false);
    setShowkmlUploder(false);
  };

  const handleCurrentLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        const { latitude, longitude } = position.coords;
        setCenter({ lat: latitude, lng: longitude });
        setCurrentLocationMarkerPosition({ lat: latitude, lng: longitude }); // Set the marker position
        
        if (isWorldView) { 
          setZoomLevel(12); // Zoom in when coming from world view
          setIsWorldView(false); // Reset world view flag after zooming in
        }
      });
    } else {
      alert("Geolocation is not supported by this browser.");
    }
  };


  const handleWorldView = () => {    
    setTimeout(() => {
      setCenter({ lat: 0, lng: 0 });
      setZoomLevel(2); // Set zoom level to 2 for world view
      setIsWorldView(true);
    }, 100);
  };
  
  //   const handleCursorCapture = () => {
  //   setCaptureCoordinates((prev) => !prev);
  // };
  const handleCursorCapture = () => {
  setIsCursorActive((prev) => !prev); // Toggle local selection state
  setCaptureCoordinates((prev) => !prev); // Your existing prop toggle
};

  const handleDefaultView = () => {
    if (!isWorldView) {
    setZoomLevel(12); // Set zoom level to 12 for default view
    }
  };

 // eslint-disable-next-line
  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file && onKMLUpload) {
      onKMLUpload(file);
    }
    setShowkmlUploder(false); // Close the popup after file selection
};

return (
  <div className="sidebar">
    {/* Coordinates Popup */}
    {showPopup && (
      <div className="popup-overlay" onClick={() => setShowPopup(false)}>
        <div className="popup-content" onClick={(e) => e.stopPropagation()}>
          <h2>Set Coordinates</h2>
          <label>
            Latitude:
            <input
              type="text"
              value={latitude}
              onChange={(e) => setLatitude(e.target.value)}
            />
          </label>
          <label>
            Longitude:
            <input
              type="text"
              value={longitude}
              onChange={(e) => setLongitude(e.target.value)}
            />
          </label>
          <div className="popup-buttons">
            <Button onClick={handleSetCoordinates}>Take Me</Button>
            <Button onClick={handleCancel}>Close</Button>
          </div>
        </div>
      </div>
    )}

    {/* KML Upload Popup */}
    {showkmluploder && (
      <div className="popup-overlay" onClick={handleCancel}>
        <div className="popup-content" onClick={(e) => e.stopPropagation()}>
          <h2>Upload KML File</h2>
          <input type="file" accept=".kml" onChange={handleFileUpload} />
          <div className="popup-buttons">
            <Button onClick={handleCancel}>Close</Button>
          </div>
        </div>
      </div>
    )}

    {window.matchMedia("(orientation: portrait)").matches && (
      <div className="sidebar-country-dropdown">
        <label htmlFor="sidebar-country-select">Select a country:</label>
        <select
          id="sidebar-country-select"
          onChange={(e) =>
            // setKmlUrl(
            //   `https://kmlgenerationgeowgs84.blob.core.windows.net/wourld-country-area-kml-files/${encodeURIComponent(
            //     e.target.value
            //   )}.kml`
            setKmlUrl(
              `https://kmlgenerationgeowgs84.blob.core.windows.net/world-country-area-kml-files/${encodeURIComponent(
                e.target.value
              )}.kml`
            )
          }
        >
          <option value="">-- Choose a country --</option>
          {Object.entries(require("../assets/countriesJSON/countries.json")).map(
            ([key, label], index) => (
              <option key={index} value={key}>
                {label}
              </option>
            )
          )}
        </select>
      </div>
    )}

    <img
      src={coordinatesIcon}
      alt="Coordinates Icon"
      className={`sidebar-logo ${selectedIcon === "coordinates" ? "selected" : ""}`}
      title="Navigate to Set coordinates"
      onClick={() => {
        setShowPopup(true);
        if (!isWorldView) {
          handleDefaultView();
        }
        handleIconClick("coordinates");
      }}
    />

    <img
      src={currentLocationIcon}
      alt="Current Location Icon"
      className={`sidebar-logo ${selectedIcon === "currentLocation" ? "selected" : ""}`}
      title="Navigate to Current Location"
      onClick={() => {
        handleCurrentLocation();
        handleDefaultView();
        handleIconClick("currentLocation");
      }}
    />

     <img
      src={cursorIcon}
      alt="Capture Coordinates Icon"
      // Use isCursorActive here instead of selectedIcon === "cursor"
      className={`sidebar-logo ${isCursorActive ? "selected" : ""}`}
      title="Navigate to Capture Coordinates"
      onClick={() => {
        handleCursorCapture();
        // We remove handleIconClick("cursor") so it doesn't interfere 
        // with the primary selection logic of other buttons
      }}
    />

    <img
      src={WorldView}
      alt="Navigate to World View Icon"
      className={`sidebar-logo ${selectedIcon === "worldView" ? "selected" : ""}`}
      title="World View"
      onClick={() => {
        handleWorldView();
        handleIconClick("worldView");
      }}
    />

    <img
      src={aoiIcon}
      alt="AOI"
      className={`sidebar-logo ${selectedIcon === "aoi" ? "selected" : ""}`}
      title="Navigate to Zoom To The AOI"
      onClick={() => {
        zoomToDrawnShapes();
        handleIconClick("aoi");
      }}
    />

    <div className="divider"><br /></div>

    <img
      src={CountryDropdown}
      alt="CountryDropdown Icon"
      className={`sidebar-logo ${selectedIcon === "CountryDropdown" ? "selected" : ""}`}
      title="Select your service area as a country"
      onClick={() => {
        handleIconClick("CountryDropdown");
        setShowSearchBox(true);
      }}
    />

    {showSearchBox && !window.matchMedia("(orientation: portrait)").matches && (
      <div className="popup-overlay" onClick={handleCancel}>
        <div className="popup-content" onClick={(e) => e.stopPropagation()}>
          <h2>Select a Country</h2>
          <select
            id="landscape-country-select"
            onChange={(e) => {
              const selectedCountry = e.target.value;
              if (selectedCountry) {
                setKmlUrl(
                  `https://kmlgenerationgeowgs84.blob.core.windows.net/world-country-area-kml-files/${encodeURIComponent(
                    selectedCountry
                  )}.kml`
                );
                setShowSearchBox(false);
              }
            }}
//             onChange={(e) => {
//   const selectedCountry = e.target.value;
//   if (selectedCountry) {
//     // 1. Construct the URL string
//     // const generatedUrl = `https://kmlgenerationgeowgs84.blob.core.windows.net/wourld-country-area-kml-files/${encodeURIComponent(selectedCountry)}.kml`;
//     const generatedUrl = `https://kmlgenerationgeowgs84.blob.core.windows.net/world-country-area-kml-files/${encodeURIComponent(selectedCountry)}.kml`;

//     // 2. Update the state
//     setKmlUrl(generatedUrl);

//     // 3. Print the actual URL string to the console
//     console.log("KML URL:", generatedUrl);

//     setShowSearchBox(false);
//   }
// }}
          >
            <option value="">-- Choose a country --</option>
            {Object.entries(require("../assets/countriesJSON/countries.json")).map(
              ([key, label], index) => (
                <option key={index} value={key}>
                  {label}
                </option>
              )
            )}
          </select>
          <div className="popup-buttons" style={{ justifyContent: "center" }}>
            <Button onClick={() => setShowSearchBox(false)}>Close</Button>
          </div>
        </div>
      </div>
    )}

    <img
      src={KMLUpload}
      alt="Upload KML"
      className={`sidebar-logo ${selectedIcon === "KMLUpload" ? "selected" : ""}`}
      title="KML Upload"
      onClick={() => handleIconClick("KMLUpload")}
    />
  </div>
);
}
export default Sidebar;
